<script lang="ts">
  /*
    Phone orientation gate. The game is landscape-only on phones:
    - Every user gesture retries fullscreen + orientation lock (Android honors
      it; iOS has no lock API and silently refuses).
    - While the phone is physically portrait, this full-screen curtain asks
      for a rotate — the game underneath is unplayable sideways anyway.
    Rendered only when isPhone() (see App.svelte).
  */
  import { device, lockLandscape } from "../device.svelte.ts";

  function onGesture() {
    void lockLandscape();
  }
</script>

<svelte:window onpointerup={onGesture} />

{#if device.portrait}
  <div class="fixed inset-0 z-[100] grid place-items-center bg-void">
    <div class="flex flex-col items-center gap-5 px-8 text-center">
      <svg viewBox="0 0 48 48" class="rotate-hint size-16 text-cyan glow-cyan" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <rect x="15" y="6" width="18" height="36" rx="3" />
        <line x1="20" y1="38" x2="28" y2="38" />
        <path d="M40 18a16 16 0 0 0-8-8" />
        <path d="m28 8 4 2-2 4" />
      </svg>
      <div class="flex flex-col gap-1.5">
        <span class="font-display text-lg font-bold uppercase tracking-[0.2em] text-ink">Rotate your device</span>
        <span class="font-body text-sm text-ink-dim">YGO Evolution plays in landscape</span>
      </div>
    </div>
  </div>
{/if}

<style>
  .rotate-hint {
    animation: rotate-nudge 2.4s var(--ease-out-quint) infinite;
  }
  @keyframes rotate-nudge {
    0%, 55%, 100% { transform: rotate(0deg); }
    20%, 40% { transform: rotate(90deg); }
  }
  @media (prefers-reduced-motion: reduce) {
    .rotate-hint {
      animation: none;
      transform: rotate(90deg);
    }
  }
</style>
